/**
 * Shrink header
 */

$j( document ).ready(function( $ ) {

    $(function() {
        var logo = $("body .top-bar .logo a");
        var topbar = $("body .top-bar");
        

        $(window).scroll(function() {    
            var scroll = $(window).scrollTop();
        
            if (scroll >= 100) {
                logo.addClass('on');
                topbar.addClass('on');

            } else if (scroll < 100) {
                logo.removeClass('on');
                topbar.removeClass('on');

            }
        });
    });

});